import { TPromoCompilationType } from '../../types/promoSelection';
import { IApplicationState } from '../../types/redux';

export const selectPromoCompilationTitle =
  (type: TPromoCompilationType) =>
  (state: IApplicationState): string => {
    const {
      promosPage: { lastChanceDiscount, topPromos },
    } = state;
    switch (type) {
      case 'topPromos':
        return topPromos.title;
      case 'lastChanceDiscount':
        return lastChanceDiscount.title;
    }
  };
